module.exports = require("ts-results");